import React, { FC } from "react";
import { styled } from "@material-ui/styles";

import { PrimaryButton } from "../../elements/Button";

type CampaignTemplatesToolbarProps = {
  onNewTemplate: () => void;
};

const Root = styled("div")({
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "center",
  marginBottom: 16,
});

const PlusIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <line x1="12" y1="5" x2="12" y2="19" />
    <line x1="5" y1="12" x2="19" y2="12" />
  </svg>
);

const CampaignTemplatesToolbar: FC<CampaignTemplatesToolbarProps> = ({ onNewTemplate }) => (
  <Root>
    <PrimaryButton type="button" onClick={onNewTemplate}>
      <PlusIcon />
      New Template
    </PrimaryButton>
  </Root>
);

export default CampaignTemplatesToolbar;
